export default __webpack_public_path__ + "static/media/clock.4e2c52bf.svg";